import { render, staticRenderFns } from "./subscription-purchase.vue?vue&type=template&id=630c3b87&scoped=true&"
import script from "./subscription-purchase.vue?vue&type=script&lang=js&"
export * from "./subscription-purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630c3b87",
  null
  
)

export default component.exports